import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app.module';
import { environment } from 'environments/environment';

if (!/localhost/.test(document.location.host)) {
	enableProdMode();
}

const cookieFirstScriptTarget = <HTMLScriptElement>document.getElementById('cookie-first-consent-script-target');
cookieFirstScriptTarget.setAttribute('src', environment.cookieFirstConsentScriptSrc);

platformBrowserDynamic().bootstrapModule(AppModule);
